var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"move-view"},[(_vm.move.card !== null)?_c('card-view',{attrs:{"card":_vm.move.card}}):_c('div',[_c('p',[_vm._v(_vm._s(_vm.move.type)+" "+_vm._s(_vm.move.value))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }